import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { JiraUserCreationSuccessComponent } from './jira-user-creation-success/jira-user-creation-success.component';
import { JiraUserService } from './service/jira-user.service';

@Component({
  selector: 'apc-jira-users',
  templateUrl: './jira-users.component.html',
  styleUrls: ['./jira-users.component.scss'],
  providers: [JiraUserService],
})
export class JiraUsersComponent implements OnInit {
  @Input() modalRef: any;
  jiraUsersSuccessRef: any;
  quickSearch = new Subject<any>();
  queryString: string = '';
  searchValue: string = '';
  result: any = '';
  isLoading: boolean = false;
  userSelected: boolean = false;
  integrated: boolean | undefined = undefined;
  public form: UntypedFormGroup;
  jiraGroups;
  userEmail: string;

  constructor(private jiraService: JiraUserService, public modalService: NgbModal) {
    this.initSingleForm();
    this.quickSearch.pipe(debounceTime(1000), distinctUntilChanged()).subscribe((input) => {
      this.search(input.value);
    });
  }

  ngOnInit(): void {
    this.jiraService.getUserGroupMembership().then((res) => {
      this.jiraGroups = res;
      this.jiraGroups.forEach(item => {
        item.descString = '';
        if(item.description) {
          item.descString += item.description;
        }
        if(item.groups && item.groups.length > 0) {
          if(item.descString.length > 0) {
            item.descString += '<br/><br/>';
          }
          item.descString += "Related groups: "
        item.groups.forEach((gr, i) => {
          item.descString += gr;
          if(i !== item.groups.length - 1) {
            item.descString += ', ';
          }
        });
      }

        // so tooltip does not show if no text
        if(item.descString.length === 0) {
          item.descString = null;
        }
      });
    });
  }

  initSingleForm() {
    this.form = new UntypedFormGroup({
      jiraUser: new UntypedFormControl(null, [Validators.required]),
    });
  }

  close() {
    this.modalRef.dismiss();
  }

  async search(value: string) {
    this.searchValue = value;
    this.queryString = this.searchValue;
    this.isLoading = true;
    this.result = [];
    this.userSelected = false;
    if (this.queryString.length > 0) {
      this.jiraService.getJiraUsers(this.queryString).then(
        (res) => {
          this.result = res;
          this.isLoading = false;
        },
        (reason) => {
          this.isLoading = false;
        }
      );
    } else {
      this.result = [];
      this.isLoading = false;
    }
  }

  closeSearch() {
    this.result = [];
    this.searchValue = '';
    this.queryString = '';
    this.integrated = undefined;
    this.isLoading = false;
    this.form.reset();
  }

  selectUser(user) {
    this.form.controls.jiraUser.patchValue(user);
    this.searchValue = user.name + ' (' + user.email + ')';
    this.userEmail = user.email;
    this.userSelected = true;
  }

  constructDisplayName(user) {
    var uid = '';
    if (user.uid.length) {
      uid = user.uid + ' | ';
    }
    var department = '';
    if (user.department.length) {
      department = user.department + ' | ';
    }
    return '<b>' + user.name + '</b>' + ' (' + user.email + ') <br/>' + uid + department + user.creationDate;
  }

  activateJiraUser(jiraUser) {
    /* #703 add groups to user */
    var selectedGroups = [];
    if(this.jiraGroups && this.jiraGroups.length > 0) {
      this.jiraGroups.forEach((item) => {
        if (item.default) {
          selectedGroups.push(item.label);
        }
      });
    }

    /*  #703 add groups to user END */

    this.jiraService.createUser(jiraUser.uid, { groups: selectedGroups }).then(
      (res: any) => {
        this.close();
        this.jiraUsersSuccessRef = this.modalService.open(JiraUserCreationSuccessComponent, {
          ariaLabelledBy: 'modal-basic',
          backdrop: 'static',
          keyboard: false,
          windowClass: 'jira-users-modal',
          backdropClass: 'jira-users-backdrop',
        });
        this.jiraUsersSuccessRef.componentInstance.modalRef = this.jiraUsersSuccessRef;
        this.jiraUsersSuccessRef.componentInstance.user = res;
        this.jiraUsersSuccessRef.componentInstance.isError = false;
      },
      (err) => {
        this.close();
        if (!err.message) {
          this.jiraUsersSuccessRef = this.modalService.open(JiraUserCreationSuccessComponent, {
            ariaLabelledBy: 'modal-basic',
            backdrop: 'static',
            keyboard: false,
            windowClass: 'jira-users-modal',
            backdropClass: 'jira-users-backdrop',
          });
          this.jiraUsersSuccessRef.componentInstance.modalRef = this.jiraUsersSuccessRef;
          this.jiraUsersSuccessRef.componentInstance.user = err;
          this.jiraUsersSuccessRef.componentInstance.email = this.userEmail;          
          this.jiraUsersSuccessRef.componentInstance.isError = true;
        }
      }
    );
  }

  hideMainModal() {
    document.getElementsByClassName('jira-users-modal')[0].setAttribute('style', 'display: none !important');
  }
}
